var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 0.5C16.4926 0.5 20.7918 3.69416 23.6319 7.01247C24.124 7.58771 24.1214 8.41932 23.6319 8.99157C22.9183 9.82528 21.4224 11.4346 19.4244 12.8408C14.3814 16.3903 9.6076 16.3825 4.57572 12.8408C2.57773 11.4346 1.08178 9.82528 0.368215 8.99157C-0.122738 8.4182 -0.122738 7.58583 0.368215 7.01247C3.20646 3.6964 7.50666 0.5 12.0001 0.5ZM17.1732 8.00183C17.1732 5.24395 14.8528 3.00049 12.0004 3.00049C9.148 3.00049 6.82764 5.24395 6.82764 8.00183C6.82764 10.7597 9.148 13.0032 12.0004 13.0032C14.8528 13.0032 17.1732 10.7597 17.1732 8.00183Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye_hide.978404eba591bffb7100f669feb4d5c7.svg";
export { ForwardRef as ReactComponent };